module.exports = __webpack_public_path__ + "img/icon-22.4038842e.svg";